<template>
  <el-aside :style="{ width: asideWidth }" class="aside">
    <div class="brand-area">
      <span class="brand-dot"></span>
      <span v-if="!isCollapse" class="brand-text">青鸾</span>
    </div>
    <div class="toggle-button" @click="isCollapse = !isCollapse">
      <el-icon>
        <component :is="isCollapse ? 'Expand' : 'Fold'" />
      </el-icon>
    </div>
    <el-menu
      :default-active="activePath"
      active-text-color="#0f7c82"
      :collapse="isCollapse"
      :collapse-transition="false"
      router
      class="app-menu"
    >
      <template v-for="item in menuRoutes" :key="item.name">
        <!-- 只渲染有标题的路由 -->
        <el-menu-item v-if="canShow(item)"
                      :index="'/main/' + item.path">
          <el-icon>
            <component :is="item.meta.icon" />
          </el-icon>
          <template #title>{{ item.meta.title }}</template>
        </el-menu-item>
      </template>
    </el-menu>
  </el-aside>
</template>

<script>
export default {
  name: 'AppAside'
}
</script>

<script setup>
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';
import router, { canAccessRoute } from "@/core/router";

const isCollapse = ref(false);
const route = useRoute();

const routes = router.getRoutes();
const mainRoute = routes.find(r => r.name === 'MainPage');
const menuRoutes = mainRoute ? mainRoute.children : [];

const asideWidth = computed(() => (isCollapse.value ? '72px' : '200px'));
const activePath = computed(() => route.path);
const canShow = (item) => {
  if (!item.meta?.title) return false;
  return canAccessRoute(item);
};
</script>

<style scoped>
.aside {
  transition: width 0.3s;
  background-color: var(--surface, #fff);
  border-right: 1px solid var(--line-light, rgba(16, 74, 88, 0.06));
  display: flex;
  flex-direction: column;
}

.brand-area {
  height: 56px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 20px;
  border-bottom: 1px solid var(--line-light);
  flex-shrink: 0;
}

.brand-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--accent, #0f7c82);
  flex-shrink: 0;
}

.brand-text {
  font-size: 16px;
  font-weight: 700;
  color: var(--text-main, #18343d);
  white-space: nowrap;
}

.toggle-button {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 18px;
  color: var(--text-soft, #627b83);
  flex-shrink: 0;
}

.toggle-button:hover {
  background: var(--accent-light, rgba(15, 124, 130, 0.06));
}

/* 菜单容器：允许滚动 */
.app-menu {
  flex: 1;
  overflow-y: auto;
  border-right: none;
  padding: 8px;
}

/* 菜单项：圆角 + 间距 + 呼吸感 */
.app-menu .el-menu-item {
  border-radius: var(--radius-sm, 8px);
  margin-bottom: 4px;
  height: 44px;
  color: var(--text-soft, #627b83);
}

.app-menu .el-menu-item:hover {
  background: var(--accent-light, rgba(15, 124, 130, 0.06));
  color: var(--text-main, #18343d);
}

.app-menu .el-menu-item.is-active {
  background: var(--accent-light, rgba(15, 124, 130, 0.06));
  color: var(--accent, #0f7c82);
  font-weight: 600;
}

/* 折叠态下隐藏品牌文字对齐 */
.el-menu--collapse .brand-text {
  display: none;
}
</style>
